import React, { Component } from "react";
import jss from "jss";
import preset from "jss-preset-default";

jss.setup(preset());

const { classes } = jss
  .createStyleSheet({
    modal: {
      zIndex: "1000",
      width: "90%",
      top: "5%",
      //height: '90%',
      position: "relative",
      margin: "0 auto",
      // backgroundColor: 'rgba(1,1,1,0.5)',
    },
    ellipsisLoader: {
      backgroundImage:
        "url(data:image/svg+xml;base64,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)",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
    closeBtn: {
      position: "absolute",
      right: -10,
      zIndex: 1001,
      top: -11,
      background: "rgba(1,1,1,0.5)",
      color: "white !important",
      paddingRight: 10,
      paddingLeft: 10,
      paddingTop: 5,
      paddingBottom: 5,
      borderRadius: "100%",
      border: "2px solid gray",
      fontSize: "1.5em !important",
      cursor: "pointer",
    },
    loaderOverlay: {
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
    },
    skipBtn: {
      fontSize: "14px !important",
      display: "inline-block !important",
      height: "36px !important",
      minWidth: "88px !important",
      padding: "6px 16px !important",
      lineHeight: "1.42857143",
      textAlign: "center",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      MsTouchAction: "manipulation",
      touchAction: "manipulation",
      cursor: "pointer",
      WebkitUserSelect: "none",
      MozUserSelect: "none",
      MsUserSelect: "none",
      userSelect: "none",
      border: "0",
      borderRadius: "2px",
      background: "#2196f3 !important",
      color: "#fff",
      outline: "0",
    },
    ripple: {
      backgroundImage:
        "url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwcHgiICBoZWlnaHQ9IjIwMHB4IiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiIGNsYXNzPSJsZHMtcmlwcGxlIiBzdHlsZT0iYmFja2dyb3VuZDogbm9uZTsiPjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjIwLjYyMTMiIGZpbGw9Im5vbmUiIG5nLWF0dHItc3Ryb2tlPSJ7e2NvbmZpZy5jMX19IiBuZy1hdHRyLXN0cm9rZS13aWR0aD0ie3tjb25maWcud2lkdGh9fSIgc3Ryb2tlPSIjZmRmZGZkIiBzdHJva2Utd2lkdGg9IjIiPjxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiIGNhbGNNb2RlPSJzcGxpbmUiIHZhbHVlcz0iMDs0MCIga2V5VGltZXM9IjA7MSIgZHVyPSIxIiBrZXlTcGxpbmVzPSIwIDAuMiAwLjggMSIgYmVnaW49Ii0wLjVzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlPjxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9Im9wYWNpdHkiIGNhbGNNb2RlPSJzcGxpbmUiIHZhbHVlcz0iMTswIiBrZXlUaW1lcz0iMDsxIiBkdXI9IjEiIGtleVNwbGluZXM9IjAuMiAwIDAuOCAxIiBiZWdpbj0iLTAuNXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIj48L2FuaW1hdGU+PC9jaXJjbGU+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iMzcuODI4MSIgZmlsbD0ibm9uZSIgbmctYXR0ci1zdHJva2U9Int7Y29uZmlnLmMyfX0iIG5nLWF0dHItc3Ryb2tlLXdpZHRoPSJ7e2NvbmZpZy53aWR0aH19IiBzdHJva2U9IiM4NWEyYjYiIHN0cm9rZS13aWR0aD0iMiI+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgY2FsY01vZGU9InNwbGluZSIgdmFsdWVzPSIwOzQwIiBrZXlUaW1lcz0iMDsxIiBkdXI9IjEiIGtleVNwbGluZXM9IjAgMC4yIDAuOCAxIiBiZWdpbj0iMHMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIj48L2FuaW1hdGU+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0ib3BhY2l0eSIgY2FsY01vZGU9InNwbGluZSIgdmFsdWVzPSIxOzAiIGtleVRpbWVzPSIwOzEiIGR1cj0iMSIga2V5U3BsaW5lcz0iMC4yIDAgMC44IDEiIGJlZ2luPSIwcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiPjwvYW5pbWF0ZT48L2NpcmNsZT48L3N2Zz4=)",
      width: 200,
      height: 200,
      paddingTop: 20,
      margin: "0 auto",
    },
  })
  .attach();

class ModalDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      closeSignalReceived: false,
      modalstyle: {},
      interacted: false,
      frameHeight: null,
    };
    this.closeModal = this.closeModal.bind(this);
    this.onContentLoaded = this.onContentLoaded.bind(this);
    this.setRef = this.setRef.bind(this);
    this.frameDataReceiver = this.frameDataReceiver.bind(this);
  }

  closeModal() {
    if (this.props.onClose) {
      this.props.onClose(this.props.dtnode, this.props.placeholder);
    }
  }

  closeModalWithDelay(delay = 1000, resultData = null) {
    this.setState({ closeDelayStarted: true }, () => {
      setTimeout(() => {
        if (this.props.onClose) {
          this.props.onClose(this.props.dtnode, this.props.placeholder, resultData);
        }
      }, delay);
    });
  }

  frameDataReceiver(e, f) {
    if (e.data && e.data.height) {
      let h = e.data.height;
      var diff = 200;
      if (h - diff >= 100) {
        h -= diff;
      }
      this.setState({ frameHeight: h, loading: false });
    }
    this.updateModalStyle();
  }

  onContentLoaded() {
    // this.setState({loading:true}, ()=> {
    // 	// this.updateDimensions()
    // 	// this.updateModalStyle();

    // 	// setTimeout(()=>{
    // 	// 	this.updateModalStyle();
    // 	// }, 500);
    // })
    var that = this;
    if (this.props.placeholder.type === "h5p") {
      this.geth5pframeProp("ref").contentWindow.postMessage("f", "*");
      this.geth5pframeProp("ref").contentWindow.postMessage("fplayer", "*");
      window.addEventListener("message", this.frameDataReceiver, false);
      window.onmessage = function (e) {
        if (~e.origin.indexOf("https://h5p.rechart.eu")) {
          if (e.data.from === "h5p") {
            let delay = that.props.placeholder.attributes.result_delay
              ? that.props.placeholder.attributes.result_delay
              : 0;

            if (e.data.data.result) {
              let success = e.data.data.result.success;
              if (that.props.placeholder.attributes.unlock_on_correctresp === "true") {
                if (success) {
                  that.setState({ closeSignalReceived: true, resultData: success });
                }
              } else {
                that.setState({ closeSignalReceived: true, resultData: success });
              }
            }

            if (that.props.placeholder.pause_on_focus) {
              if (e.data.data.clicked) {
                that.setState({ interacted: true }, () => {
                  if (that.props.pauseMedia) {
                    that.props.pauseMedia();
                  }
                });
              }
            }
          }
        } else {
          return;
        }
      };

      if (this.props.placeholder.attributes.after_display_duration) {
        setTimeout(() => {
          let delay = that.props.placeholder.attributes.result_delay
            ? that.props.placeholder.attributes.result_delay
            : 0;
          if (!that.state.interacted) {
            that.closeModalWithDelay(delay);
          }
        }, this.props.placeholder.attributes.after_display_duration);
      }
    }
  }

  getContent() {
    if (this.props.placeholder) {
      if (this.props.placeholder.type === "h5p") {
        let style = {
          height: "100%",
        };
        if (this.state.loading) {
          style.visibility = "hidden";
        }
        return (
          <iframe
            style={style}
            onLoad={this.onContentLoaded}
            ref={(input) => {
              this.h5pframe = input;
            }}
            src={this.props.placeholder.data.embed_url}
            frameBorder="0"
            allowFullScreen="allowfullscreen"
          ></iframe>
        );
      }
    }
  }

  loader() {
    if (this.state.loading) {
      let text = "Loading content";
      // if (this.state.closeDelayStarted){
      // 	text = "Saving Data...";
      // }
      return <div className={classes.ripple}>{text}</div>;
    }
  }

  componentWillUnmount() {
    // console.log("Unmounting placeholder id = ", this.props.placeholder.id)
    window.removeEventListener("message", this.frameDataReceiver, false);
  }

  componentDidMount() {
    // console.log("Now Mounting placeholder id = ", this.props.placeholder.id)
    this.updateModalStyle();
  }

  getModalWidth() {
    if (this.modalRef) {
      return this.modalRef.clientWidth;
    }
    return 0;
  }

  geth5pframeProp(prop) {
    if (prop === "ref") {
      return this.h5pframe;
    }
    if (prop in this.h5pframe) {
      let val = this.h5pframe[prop];

      if (prop === "clientHeight" || prop === "offsetHeight") {
        // console.log("Frame Height value = ", val);
      }
      return val;
    }
  }

  updateModalStyle() {
    let style = {};
    var that = this;
    if (this.props.placeholder.attributes.positionStyle === "custom") {
      style.position = "relative";
      if (this.props.placeholder.attributes.positionX) {
        style.margin = 0;
        style.left = this.props.placeholder.attributes.positionX;
      }
      if (this.props.placeholder.attributes.positionY) {
        style.top = this.props.placeholder.attributes.positionY;
      }
    }
    if (this.props.placeholder.attributes && this.props.placeholder.attributes.alignHorizontal) {
      switch (this.props.placeholder.attributes.alignHorizontal) {
        case "left":
          style.position = "absolute";
          style.left = 10;
          break;
        case "center":
          style.position = "absolute";
          let w = that.props.playerWidth();
          var mywidth = this.geth5pframeProp("clientWidth");
          let left = w / 2 - mywidth / 2;
          style.left = left;
          break;
        case "right":
          style.position = "absolute";
          style.right = 10;
          break;
      }
    }
    if (this.props.placeholder.attributes && this.props.placeholder.attributes.alignVertical) {
      // style.position = 'absolute';
      switch (this.props.placeholder.attributes.alignVertical) {
        case "top":
          style.top = 10;

          break;
        case "center":
          var myheight = this.state.frameHeight;
          var h = that.props.playerHeight() / 2 - myheight / 2;
          style.top = h;

          break;
        case "bottom":
          // if (style.position == 'relative'){
          // 	style.left = that.props.playerWidth()/2 - (this.getModalWidth()/2)
          // }
          if (that.modalRef) {
            style.position = "absolute";
            var myheight = this.state.frameHeight;
            var h = that.props.playerHeight();
            style.top = h - myheight; //for the button;
          }
          break;
      }
    }
    // if (this.h5pframe){
    // 	var h = this.geth5pframeProp('offsetHeight');;
    // 	style.height = h+100;
    // }
    if (this.state.frameHeight) {
      style.height = this.state.frameHeight;
    }
    if (this.props.placeholder.attributes && this.props.placeholder.attributes.sizeStyle !== "automatic") {
      if (this.props.placeholder.attributes.sizeStyle === "custom") {
        if ("width" in this.props.placeholder.attributes) {
          style.width = this.props.placeholder.attributes.width;
        }
        if ("height" in this.props.placeholder.attributes) {
          style.height = this.props.placeholder.attributes.height;
        }
      }
      if (this.props.placeholder.attributes.sizeStyle === "fullscreen") {
        style.top = 0;
        style.left = 0;
        style.width = "100%";
        style.height = "100%";
      }
    }
    if (this.state.loading) {
      style.position = "absolute";
      style.left = "-999em";
    } else {
      // style.left = '0';
      style.display = "block";
    }
    // style.overflow = 'hidden';
    // style.padding = 20;
    this.setState({ modalstyle: style });
    // return style;
  }

  bottomButtonBar() {
    if (this.props.placeholder.attributes && this.props.placeholder.attributes.skipBtn === "true") {
      let containerStyle = { position: "absolute" };
      if (this.props.placeholder.attributes.sizeStyle === "custom") {
        if (this.props.placeholder.attributes.width) {
          containerStyle.width = this.props.placeholder.attributes.width;
        }
      }
      return (
        <div style={containerStyle}>
          <button className={classes.skipBtn} onClick={this.closeModal}>
            Skip
          </button>
        </div>
      );
    }
  }

  bottomAdditionalButtonsBar() {
    if (this.state.closeSignalReceived) {
      let containerStyle = { position: "absolute" };
      if (this.modalRef && this.modalRef.offsetWidth) containerStyle.width = this.modalRef.offsetWidth;
      let resultData = null;
      if (this.state.resultData) {
        resultData = this.state.resultData;
      }
      return (
        <div style={containerStyle}>
          <button
            onClick={() => {
              this.closeModalWithDelay(0, resultData);
            }}
            className={classes.skipBtn}
          >
            Close and Continue playing
          </button>
        </div>
      );
    }
  }

  bottomTextBar() {
    if (this.state.closeDelayStarted)
      return (
        <div style={{ marginTop: 20 }}>
          Taking you back to the video...
          <div className={classes.ellipsisLoader} style={{ height: 50 }}></div>
        </div>
      );
  }

  setRef(input) {
    this.modalRef = input;
  }

  debugInfo() {
    return null;
    let j = "";
    if (this.props.placeholder.attributes && this.props.placeholder.attributes.alignVertical) {
      j = JSON.stringify(this.props.placeholder.attributes.alignVertical);
    }
    return <div>{j}</div>;
  }

  render() {
    // let injector = {}
    let allStyles = this.state.modalstyle;
    let outerStyle = {
      width: this.props.playerWidth(),
      top: 0,
      padding: 0,
      height: this.props.playerHeight(),
      position: "absolute",
      zIndex: 1000,
    };
    if (this.props.play_with_controls) {
      outerStyle.height = this.props.playerHeight() - 49;
    }
    // allStyles = Object.assign(allStyles, injector});
    return (
      <div style={outerStyle}>
        {this.state.loading ? <div className={classes.loaderOverlay}>{this.loader()}</div> : null}
        <div className={classes.modal} style={allStyles} ref={this.setRef}>
          {this.props.placeholder.attributes && this.props.placeholder.attributes.hide_close === "false" ? (
            <div className={classes.closeBtn} onClick={this.closeModal}>
              x
            </div>
          ) : null}
          {this.debugInfo()}
          {this.getContent()}
          {this.bottomButtonBar()}
          {this.bottomTextBar()}
          {this.bottomAdditionalButtonsBar()}
        </div>
      </div>
    );
  }
}

export default ModalDialog;
